import React, {Component} from 'react';
import {i18n_t} from 'app/i18n';
import {isGuest, secondsToShortHoursFormat, userSignedIn} from 'app/utils';
import {openRegistration} from 'app/components/auth/auth';
import {linkMyHero} from 'app/utils/app_links';
import TPromoActionStore from 'app/interfaces/stores/TPromoActionStore';
import {userStore} from 'app/store/global';
import {PromoActionsWithBonuses} from 'app/utils/Consts';

interface ConvertButtonBaseProps {
    promoActionStore?: TPromoActionStore,
    onClickHandler(): void,
    classes?: string[]
}

export default class ConvertButtonBase extends Component<ConvertButtonBaseProps> {
    defaultClassNames = (): string[] => ['button-adaptive button-adaptive_bigger-full-light'];

    className = (): string => {
        const classes = this.props.classes ?? this.defaultClassNames();

        if (this.isDisabled()) {
            classes.push('btn--disable');
        }

        return classes.join(' ');
    };

    isTimerUnavailable = (): boolean => {
        throw new Error();
    };

    nextConversionIn = (): React.ReactNode | null => {
        const {promoAction: {next_conversion_in}} = this.props.promoActionStore;

        if (this.isTimerUnavailable()) {
            return null;
        }

        return <span className="prediction-timer">{secondsToShortHoursFormat(next_conversion_in)}</span>;
    };

    onClickHandler = ():void => {
        if (userSignedIn()) {
            this.props.onClickHandler();
        } else {
            openRegistration(linkMyHero(false), null, 'login');
        }
    };

    isDisabled = (): boolean => {
        const {isConversionAvailableNow} = this.props.promoActionStore;

        if (isGuest()) {
            return false;
        }

        return !isConversionAvailableNow;
    };

    render(): React.ReactNode {
        const [promoActionKey] = Object.keys(this.props.promoActionStore.promoActions);

        if (!this.props.promoActionStore.promoAction) {
            return null;
        }
        if (PromoActionsWithBonuses.includes(promoActionKey) && userStore.user.beer_and_gift_promo_disabled) {
            return null;
        }

        return (
            this.nextConversionIn() || <button
                disabled={this.isDisabled()}
                onClick={this.onClickHandler}
                className={this.className()}
            >{i18n_t('scatter.button')}</button>
        );
    }
}
